import '../../styles/login.css';
import '../../styles/sk.css';
import '../../styles/register.css';
import {motion as m} from "framer-motion"
import React, {useEffect, useState} from "react";
import { Nav } from "../../components/navComponents"
import SealVectorService from "../../App/Services/Bll/SealVectorService";
import FileModel from "../../StarterKit/Model/FileModel";
import SettingService from "../../StarterKit/Service/Bll/SettingService";
import {ImportComponent} from "../../StarterKit/Components/ImportComponent";
import {useNavigate} from "react-router-dom";
import ShopService from "../Services/Bll/ShopService";
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import ObjectifService from "../Services/Bll/ObjectifService";

export default function Imports() {
    const [post, setPost] = React.useState(null);
    const [nbSeal, setNbSeal] = useState({});
    const [nbModels, setNbModels] = useState({});
    const [nbShops, setNbShops] = useState({});
    const [reload, setReload] = useState(false);

    const [products, setProducts] = useState(null);

    var objService = new ObjectifService();
    var settingService = new SettingService();
    var fileModel = new FileModel()
    let navigate = useNavigate()

    // React.useEffect(() => {
    // },[reload])


    const submitForm = async (e) => {
        e.preventDefault()
        let form = $(e.target).closest('form')
        var imagefile = form.find('#file')[0];
        var type = form.find('#type').val();
        fileModel.file = imagefile.files[0]
        if (imagefile.files[0] && type){
            fileModel.title = imagefile.files[0].name
            let res = await sealVectorService.import(fileModel,type)
            window.location.reload()
        }

    };

    async function  submit(formName) {
        $("body").css('cursor','wait');
        var sealVectorService = new SealVectorService();
        var fileModel = new FileModel()
        var file = $('#'+ formName+'_form input[type="file"]')[0].files[0];
        if (file) {
            fileModel.title = file.name
            fileModel.file = file
            await sealVectorService.import(fileModel,formName);
            setReload(!reload)
            window.location.reload()
        }
        $("body").css('cursor','default');
    }

    return (
        <>
            <m.div className={"wrapper"}>
                <Nav />
                <div id={"page"}>

                    <div id="content">
                        <div className="card">
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col-6">
                                        <h3>{CacheExtension.getDataFromCache("Imports")}</h3>
                                        <input type="hidden" defaultValue={1} id="users_page"/>
                                        <input type="hidden" defaultValue={1} id="users_pageCount"/>
                                    </div>
                                </div>
                            </div>
                            <div className={"card-body"}>
                                <div id={"page"}>
                                    <div className="App">
                                        <>
                                            <ImportComponent formName = {'Import budget et objectifs (Destinations, réseaux)'} form = {true} modele={'modele_budget.csv'} action={async (file) => {
                                                await objService.import(file);
                                                setReload(!reload)
                                            }}/>
                                            <ImportComponent formName = {'Import objectifs des commerciaux'} form = {true} modele={'modele_objectifs_commerciaux.csv'}  action={async (file) => {
                                                await objService.importCommerciaux(file);
                                                setReload(!reload)
                                            }}/>
                                        </>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </m.div>
        </>
    );

}








